import AREA from './_area';
export default {
  AREA
};
